import React from "react";
import classNames from "classnames/bind";
import styles from "../AddJobModal.module.scss";
import { ArrowRight2Icon } from "~/assets/icons";
import { ModalStep, JobStep } from "../types/add-job.types";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";

const cx = classNames.bind(styles);

interface AddJobModalActionsProps {
  currentStep: ModalStep;
  jobStep: JobStep;
  onBack?: () => void;
  onContinue: () => void;
  onAddContact?: () => void;
  addContactDisabled?: boolean;
  disabled?: boolean;
}

const AddJobModalActions: React.FC<AddJobModalActionsProps> = ({
  currentStep,
  jobStep,
  onBack,
  onContinue,
  onAddContact,
  addContactDisabled = false,
  disabled = false,
}) => {
  if (currentStep === 1) {
    return (
      <div
        className={cx("action-buttons", { "two-buttons": jobStep === "New" })}
      >
        {jobStep === "New" ? (
          <>
            <PrimaryButton
              title="Add Contact"
              onClick={onAddContact ?? onContinue}
              className={cx("add-contact-button")}
              disabled={addContactDisabled}
            />
            <PrimaryButton
              title="Continue"
              icon={<ArrowRight2Icon className={cx("continue-icon")} />}
              iconPosition="right"
              onClick={onContinue}
              className={cx("add-address-button")}
              disabled={disabled}
            />
          </>
        ) : (
          <PrimaryButton
            title="Continue"
            icon={<ArrowRight2Icon className={cx("continue-icon")} />}
            iconPosition="right"
            onClick={onContinue}
            className={cx("add-address-button")}
            disabled={disabled}
          />
        )}
      </div>
    );
  }

  return (
    <div className={cx("action-buttons")}>
      {onBack && (
        <PrimaryButton
          title="Back"
          onClick={onBack}
          className={cx("cancel-button")}
        />
      )}

      {currentStep !== 3 && (
        <PrimaryButton
          title="Continue"
          icon={<ArrowRight2Icon className={cx("continue-icon")} />}
          iconPosition="right"
          onClick={onContinue}
          className={cx("add-address-button")}
          disabled={disabled}
        />
      )}

      {currentStep === 3 && (
        <PrimaryButton
          title="Create Job"
          onClick={onContinue}
          className={cx("add-address-button")}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default AddJobModalActions;
